import React, { useEffect, useState } from 'react';
import {
  Navbar,
  Container,
  Dropdown,
  Image
} from 'react-bootstrap';
import { FaUser, FaSignOutAlt } from 'react-icons/fa';
import { useLocation, useNavigate } from 'react-router-dom';
import defaultProfileImg from '../assets/img/avatar.png';
import { auth, db } from '../firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import Notification from '../calculations/Notification';

const DashboardNavbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [displayName, setDisplayName] = useState('User');
  const [profileImg, setProfileImg] = useState(defaultProfileImg);
  const [role, setRole] = useState('');
  const routeTitleMap = {
    // '/': 'Dashboard',
    '/dashboard': 'Dashboard',
    '/transactions': 'Transactions',
    '/users': 'Users',
    '/currencies': 'Currencies',
    '/price_config': 'Price Config',
    //'/operators': 'Operators',
    '/packages': 'Packages',
    '/global_exchange' : 'Global Exchange',
    '/countries': 'Countries',
    '/settings': 'Settings',
    '/fraud/dashboard': 'Fraud Dashboard',
    '/fraud/logs': 'Fraud Logs',
    '/fraud/blacklist': 'Blacklist',
    '/fraud/rules': 'Fraud Rules',
    '/fraud/suspended': 'Suspended Users',
  };

  const pageTitle = routeTitleMap[location.pathname] || 'Dashboard';

  useEffect(() => {
    const adminRole = localStorage.getItem("adminRole") || "manager";
    setRole(adminRole);

    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        const uid = currentUser.uid;
        const name = currentUser.displayName;

        if (name && name.trim().length > 0) {
          setDisplayName(name);
        } else if (currentUser.email) {
          const fallbackName = currentUser.email.split('@')[0];
          setDisplayName(fallbackName.charAt(0).toUpperCase() + fallbackName.slice(1));
        }

        try {
          const userRef = doc(db, 'users', uid);
          const snapshot = await getDoc(userRef);
          if (snapshot.exists()) {
            const data = snapshot.data();
            if (data.image) {
              setProfileImg(data.image);
            }
          }
        } catch (err) {
          console.error("Error fetching image:", err.message);
        }
      } else {
        setDisplayName('User');
        setProfileImg(defaultProfileImg);
      }
    });

    return () => unsubscribe();
  }, []);

  const handleProfile = async () => {
    navigate('/settings');
  };
  const handleLogout = async () => {
    await signOut(auth);
    navigate('/signin');
  };

  return (
    <Navbar
      expand="lg"
      fixed="top"
      className="px-3 shadow-sm"
      style={{
        height: '70px',
        zIndex: 1030,
        marginLeft: '280px',
        width: 'calc(100% - 280px)',
        background: 'linear-gradient(135deg, var(--primary-purple), var(--bg-surface))',
        borderBottom: '1px solid var(--divider)',
      }}
    >
      <Container fluid className="d-flex align-items-center flex-wrap">
        <div className="me-auto">
          <h2 className="text-h1 mb-0" style={{ color: 'var(--text-primary)' }}>{pageTitle}</h2>
        </div>

        {/* Right: Notifications & Profile */}
        <div className="d-flex align-items-center gap-2 ms-auto">
          <div className="btn d-flex align-items-center justify-content-center position-relative">
            <Notification />
          </div>
          
          <Dropdown align="end">
            <Dropdown.Toggle
              className="d-flex align-items-center gap-2 px-2 rounded hover-drop"
              style={{ cursor: 'pointer', background: 'transparent', border: 'none' }}
            >
              <div
                className="rounded-circle overflow-hidden"
                style={{ width: '52px', height: '52px', border: '2px solid var(--divider)' }}
              >
                <Image src={profileImg} alt="Profile" fluid className="w-100 h-100" />
              </div>
              <div className="d-none d-md-block text-start">
                <p className="mb-0 fw-semibold navbar-profile-name" style={{ fontSize: '14px', lineHeight: '1.2' }}>
                  {displayName}
                </p>
                <small className="navbar-profile-role" style={{ fontSize: '11px', display: 'block', marginTop: '2px' }}>
                  {role === "super_admin" ? "Super admin" : (role.charAt(0).toUpperCase() + role.slice(1))}
                </small>
              </div>
            </Dropdown.Toggle>

            <Dropdown.Menu className="shadow-sm mt-2 rounded navbar-dropdown-menu">
              <Dropdown.Item onClick={handleProfile} href="#" className="d-flex align-items-center">
                <FaUser className="me-2" /> Profile
              </Dropdown.Item>
              <Dropdown.Item onClick={handleLogout} className="d-flex align-items-center">
                <FaSignOutAlt className="me-2" /> Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </Container>
    </Navbar>
  );
};

export default DashboardNavbar;
